import { ClientError } from './client-error';

export class ConfigurationValidationError extends ClientError {
  constructor(message?: string) {
    super(message);

    this.name = 'ConfigurationValidationError';
  }
}
